import { IPublicClientApplication } from '@azure/msal-browser';

export const signOut = (instance: IPublicClientApplication): void => {
  const activeAccount = instance.getActiveAccount();
  if (!activeAccount) return;

  instance.logoutRedirect({
    account: activeAccount,
    postLogoutRedirectUri: '/',
  });
};
